<div
  class="dt-outer"
  [class.dt-seamless]="seamless"
  [class]="wrapperClass"
  [style.border-radius]="borderRadius"
  [style.box-shadow]="shadow"
  [style.border]="border"
>
  <!-- Persistent live region: its text changes, so 'Loading' is announced each time. -->
  <span class="bk-sr-only" role="status">{{ loading ? 'Loading' : '' }}</span>
  @if (loading) {
  <div class="dt-skeleton-wrapper scrollbar-hover" [style.max-height]="maxHeight">
    <table class="dt-skeleton-table" aria-hidden="true">
      <thead>
        <tr>
          @for (col of skeletonColsArr; track $index) {
          <th class="dt-skeleton-th">
            <div class="skel-bar w-20 h-3 rounded"></div>
          </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of skeletonRowsArr; track $index) {
        <tr class="dt-skeleton-row">
          @for (col of skeletonColsArr; track i; let i = $index) {
          <td class="dt-skeleton-td">
            <div
              class="skel-bar rounded"
              [class]="i === 0 ? 'w-4 h-3' : i === skeletonColsArr.length - 1 ? 'w-8 h-3' : 'h-3'"
              [style.width]="i === 0 ? '1rem' : i === skeletonColsArr.length - 1 ? '2rem' : (60 + (i * 13) % 40) + '%'"
            ></div>
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>
  } @else {
  <!-- Focusable so keyboard users can scroll a table that overflows. -->
  <div
    class="dt-scroll-container scrollbar-hover"
    tabindex="0"
    role="region"
    [attr.aria-label]="label"
    [style.max-height]="maxHeight"
    [colResize]="resizable"
    [colResizeKey]="resizeKey"
  >
    <ng-content />
  </div>
  }
</div>
